// extracted by css-extract-rspack-plugin
export default {"shortened":"kOub7C"};